import React from "react";
import { IconButton } from "@mui/material";
import { InfoOutlined, ModeEditOutlineTwoTone } from "@mui/icons-material";
import { Link } from "react-router-dom";

import AppTable from "components/Shared/AppTable";

import { useTablePagination } from "hooks";
import { localizeDateShort } from "utils/dateFormats";
import { useVehicleDetailContext } from "contexts/VehicleDetailContext";
import { useListVehicleLocationByVehicleIdQuery} from "store/services/realTimeTrackingApi";

const VehicleLocationListByVehicle = () => {
  const { vehicleDetail } = useVehicleDetailContext();
  
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();

  const columns = [
    {
      name: "Tracking ID",
      selector: (row) => row?.trackingId,
      cell: (row) => row?.trackingId || "N/A",
    },
    {
      name: "Timestamp",
      selector: (row) => localizeDateShort(row?.timestamp),
      cell: (row) => localizeDateShort(row?.timestamp) || "N/A",
    },
    {
      name: "Location",
      selector: (row) => ` Lat: ${row?.location?.lat}, Lon: ${row?.location?.lon}`,
      cell: (row) =>
        row?.location?.lat && row?.location?.lon
          ? `Lat: ${row.location.lat}, Lon: ${row.location.lon}`
          : "N/A",
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => row?.status || "N/A",
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Link to={`/app/crm/realtime-tracking/${row?._id}/detail`}>
            <IconButton size="small" aria-label="View Tracking Record" color="primary">
              <InfoOutlined />
            </IconButton>
          </Link>
          <Link to={`/app/crm/realtime-tracking/${row?._id}/edit`}>
            <IconButton size="small" aria-label="Edit Tracking Record">
              <ModeEditOutlineTwoTone />
            </IconButton>
          </Link>
        </>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  // RTK Query
  const { data: vehicleTrackingRs, isLoading, isFetching } =
    useListVehicleLocationByVehicleIdQuery({
      vehicleId: vehicleDetail?._id,
      page: currentPage,
      limit: perPage,
    });

  return (
    <div>
      <AppTable
        columns={columns}
        data={vehicleTrackingRs?.data ?? []}
        progressPending={isLoading || isFetching}
        paginationServer
        paginationPerPage={perPage}
        paginationTotalRows={vehicleTrackingRs?.totalItems ?? 0}
        paginationDefaultPage={currentPage}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
      />
    </div>
  );
};

export default VehicleLocationListByVehicle;